@if (largestImageUrl() && fetchPriority() && loadingPriority() && !isPriority()) {
  <img
    [alt]="imageAlt()"
    [height]="largestHeight()"
    [ngClass]="cssClasses()"
    [ngSrc]="largestImageUrl()"
    [ngSrcset]="widthsSrcset()"
    [routerLink]="isClickable() ? routePath() : null"
    [sizes]="sizes()"
    [width]="largestWidth()"
    class="vd-card-image"
    [attr.fetchpriority]="fetchPriority()"
    [loading]="loadingPriority()"
  >
}
@if (largestImageUrl() && fetchPriority() && loadingPriority() && isPriority()) {
  <img
    [alt]="imageAlt()"
    [height]="largestHeight()"
    [ngClass]="cssClasses()"
    [ngSrc]="largestImageUrl()"
    [ngSrcset]="widthsSrcset()"
    [routerLink]="isClickable() ? routePath() : null"
    [sizes]="sizes()"
    [width]="largestWidth()"
    class="vd-card-image"
    [attr.fetchpriority]="fetchPriority()"
    [priority]="shouldUsePriority()"
  >
}
